module.exports = __webpack_public_path__ + "static/media/laptop_phone_dashboard_v2.016eaa59.png";